import PropTypes from "prop-types";
import React from "react";

import FieldLimitedAutocompleteLegalEntity from "./FieldLimitedAutocompleteLegalEntity";

FormFieldLimitedAutocompleteLegalEntityWrapper.propTypes = {
  control: PropTypes.object,
  field: PropTypes.any,
  fieldState: PropTypes.any,
  formState: PropTypes.any,
  helperText: PropTypes.any,
  label: PropTypes.node,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  options: PropTypes.object,
};
export default function FormFieldLimitedAutocompleteLegalEntityWrapper({
  control,
  field: { onBlur: _onBlur, onChange: _onChange, ref, value = null },
  fieldState: { error, invalid },
  formState,
  helperText,
  label,
  onBlur,
  onChange,
  options,
  ...props
}) {
  const showError = !!invalid;

  function handleChange(inn) {
    onChange(inn || null);
  }

  return (
    <FieldLimitedAutocompleteLegalEntity
      { ...props }
      defaultValue={value}
      disabled={props.disabled || false}
      error={showError}
      helperText={(showError && error?.message) || helperText}
      inputRef={ref}
      label={label}
      onBlur={onBlur}
      onChange={handleChange}
      options={options}
    />
  );
}
